import Logo from './Logo';
import AnimatedGradientLayer from './AnimatedGradientLayer';
import { motion, AnimatePresence } from 'motion/react';
import { useEffect, useState } from 'react';

const Landing = ({ elementsVisible = true }) => {
  const phrases = [
    "How do your data center\nneeds change as AI scales?",
    "How is your network evolving to\nmeet the demands of AI and IoT?",
    "How are you transforming your\nworkplace to harness AI?",
    "How quickly can you detect and\nstop critical incidents to prevent downtime?",
    "How do you counter escalating\nthreats in the AI era?",
    "How is AI empowering\nyour IT team?"
  ];

  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPhraseIndex((prevIndex) => (prevIndex + 1) % phrases.length);
    }, 20000); // Cambia cada 20 segundos

    return () => clearInterval(interval);
  }, [phrases.length]);

  return (

        <div
          className="fixed inset-0 z-[9999] bg-[#07182D] flex flex-col items-center"
        >
          {/* Logo */}
          <motion.div
            animate={{
                opacity: elementsVisible ? 1 : 0,
                filter: elementsVisible ? "blur(0px)" : "blur(10px)"
            }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <Logo className="w-373u h-auto mt-251u mb-296u" />
          </motion.div>
          

          {/* Texto */}
          <div className="text-center text-210u leading-252u font-light">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentPhraseIndex}
                initial={{ opacity: 0, filter: "blur(10px)" }}
                animate={{ opacity: elementsVisible ? 1 : 0, filter: elementsVisible ? "blur(0px)" : "blur(10px)" }}
                exit={{ opacity: 0, filter: "blur(10px)" }}
                transition={{ duration: 1, ease: "easeOut" }}
                className="whitespace-pre-line"
              >
                {phrases[currentPhraseIndex]}
              </motion.div>
            </AnimatePresence>
          </div>

          <AnimatedGradientLayer />
        </div>
  );
};

export default Landing;